export default __webpack_public_path__ + "static/media/icon-end-case.29493bf5.svg";